/* eslint-disable import/no-anonymous-default-export */
export default {
  "exception.back": "Zurück zum Start",
  "exception.403.title":
    "Entschuldigung, Sie haben keinen Zugang zu dieser Seite",
  "exception.404": "404",
  "exception.404.title":
    "Dieser Link scheint nicht mehr zu existieren oder Sie sind verloren",
  "exception.404.message":
    "Kontaktieren Sie die Person, die Ihnen diesen Link gesendet hat, und bitten Sie sie, ihn zu überprüfen",
  "exception.500.title": "Entschuldigung, der Server meldet einen Fehler",
};
